import React from "react"
import Basic from "../components/forms/Basic"

const BasicDataPage = () => {
  return (
    <>
      <Basic />
    </>
  )
}

export default BasicDataPage
